var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psi"},[_c('div',{staticClass:"inCard"}),_c('div',{staticClass:"shop-header"}),_c('StagTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }